<template>
  <div class="main-wrapper">
    <div class="login-container">
      <div class="login-card">
        <h3 class="login-title">{{ $t("Кириш ойнаси") }}</h3>

        <form @submit.prevent>
          <!-- Склад -->
          <div class="custom-form-group">
            <label class="custom-label">{{ $t("Склад") }}</label>
            <v-select :clearable="true" :options="skladlist" class="my-v-select" @input="Userlists()" v-model="sklad_id"
              :reduce="name => name.id" label="name"></v-select>
          </div>

          <!-- Ходим -->
          <div class="custom-form-group">
            <label class="custom-label">{{ $t("Ходим") }}</label>
            <v-select :clearable="true" :options="Userlist" class="my-v-select" v-model="username"
              :reduce="username => username.username" label="username">
              <template #search="{ attributes, events }">
                <input class="vs__search" ref="focused" :required="!username" v-bind="attributes" v-on="events" />
              </template>
            </v-select>
          </div>

          <!-- Парол -->
          <div class="custom-form-group">
            <label class="custom-label">{{ $t("Парол") }}</label>
            <input type="password" v-model="password" id="programmer" class="my-input" @change="errors = ''"
              placeholder="••••••" />
            <small class="error-text" v-if="errors != ''">{{ $t(errors) }}</small>
          </div>

          <!-- Кириш тугмаси -->
          <button type="button" class="btn-main" @click="Login()">
            {{ $t("Кириш") }}
          </button>

          <!-- Pastki qism -->
          <div class="extra-actions">
            <div class="row-buttons">
              <button type="button" class="btn-pay" @click="ClientPay()">{{ $t("Тўлов") }}</button>
              <button type="button" class="btn-update" @click="Updatetime()">{{ $t('Янгилаш') }}</button>
            </div>
            <router-link :to="{ path: '/sendsms' }" class="id-link">
              {{ $t("ИД Ўзгартириш") }}
            </router-link>
          </div>
        </form>
      </div>
    </div>

    <!-- Modal uchun CSS pastda -->
    <b-modal id="modal-pay" hide-footer size="md" @shown="FocusToSecret" centered title="Тўлов қилиш">
      <div class="modal-body-custom">
        <div class="modal-row full">
          <label>{{ $t("ИД рақам") }}*</label>
          <input ref="secretcode" type="text" class="my-input" v-model="pay.SecretCode" @blur="CheckSecretCode()">
          <small v-if="check_Secret_code" class="error-text">ID to'ldirilishi shart</small>
        </div>

        <div class="modal-grid">
          <div class="modal-row">
            <label>Клиент</label>
            <div class="val-box">{{ pay.projectOwner }}</div>
          </div>
          <div class="modal-row">
            <label>{{ $t("Ижара суммаси") }}</label>
            <div class="val-box">{{ pay.rentalPrice | numFormat }}</div>
          </div>
        </div>

        <div class="modal-grid" v-if="pay.payment_Method == 0 || pay.payment_Method == 1">
          <div class="modal-row">
            <label>{{ pay.payment_Method == 0 ? $t("Кун") : $t("Ой") }}</label>
            <input v-if="pay.payment_Method == 0" type="number" class="my-input" v-model="pay.day"
              @change="Summa()">
            <input v-else type="number" class="my-input" v-model="pay.month"
              @change="Summa()">
          </div>
          <div class="modal-row">
            <label>Тўлов сумма</label>
            <div class="val-box highlight">{{ pay.amount | numFormat }}</div>
          </div>
        </div>

        <div class="modal-row full">
          <label>{{ $t("Карта рақами") }}*</label>
          <input type="text" class="my-input" placeholder="0000 0000 0000 0000" v-model="pay.cardNumber">
        </div>

        <div class="modal-grid mt-2">
          <div class="modal-row">
            <label>SMS kod</label>
            <div class="sms-group">
              <input type="text" class="my-input" v-model="pay.otp">
              <button type="button" class="btn-sms" @click="SendSms()">Kod</button>
            </div>
          </div>
          <div class="modal-row">
            <label>Muddati</label>
            <input type="text" class="my-input" placeholder="2412" v-model="pay.expireDate">
          </div>
        </div>

        <button class="btn-main mt-4" @click="SendPay()">{{ $t("Тўловни юбориш") }}</button>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
/* Asosiy fon */
.main-wrapper {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle, rgba(45, 46, 47, 1) 20%, rgba(111, 142, 148, 1) 100%);
  padding: 20px;
  box-sizing: border-box;
}

/* Login Karta */
.login-container {
  width: 100%;
  max-width: 450px;
  /* Desktopda kengligi */
}

.login-card {
  background: #ffffff;
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
  width: 100%;
  box-sizing: border-box;
}

.login-title {
  text-align: center;
  margin-bottom: 30px;
  font-size: 24px;
  font-weight: 700;
  color: #333;
}

/* Form elementlari */
.custom-form-group {
  margin-bottom: 20px;
}

.custom-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #555;
  font-size: 14px;
}

.my-input {
  width: 100%;
  height: 48px;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 0 15px;
  font-size: 16px;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.3s;
}

.my-input:focus {
  border-color: #4a90e2;
}

/* V-Select dizayni */
.my-v-select>>>.vs__dropdown-toggle {
  height: 48px;
  border-radius: 10px;
  border: 1px solid #ddd;
}

.my-v-select>>>.vs__selected {
  font-size: 16px;
}

/* Tugmalar */
.btn-main {
  width: 100%;
  height: 50px;
  background: #2d2e2f;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.3s;
  margin-top: 10px;
}

.btn-main:hover {
  opacity: 0.9;
}

.extra-actions {
  margin-top: 25px;
  text-align: center;
}

.row-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.btn-pay {
  flex: 1;
  background: #007bff;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
}

.btn-update {
  flex: 1;
  background: #6c757d;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
}

.id-link {
  display: block;
  color: #007bff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
}

.error-text {
  color: #dc3545;
  font-size: 12px;
  margin-top: 5px;
  display: block;
}

/* Modal ichi dizayni */
.modal-body-custom {
  padding: 10px;
}

.modal-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 15px;
}

.modal-row {
  margin-bottom: 15px;
}

.modal-row.full {
  width: 100%;
}

.modal-row label {
  display: block;
  font-size: 13px;
  color: #666;
  margin-bottom: 5px;
}

.val-box {
  background: #f1f3f5;
  height: 45px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-radius: 8px;
  font-weight: 600;
  border: 1px solid #eee;
}

.val-box.highlight {
  color: #28a745;
}

.sms-group {
  display: flex;
  gap: 5px;
}

.btn-sms {
  background: #17a2b8;
  color: white;
  border: none;
  padding: 0 15px;
  border-radius: 8px;
  cursor: pointer;
}

/* Mobil moslashuv */
@media (max-width: 480px) {
  .login-card {
    padding: 25px 20px;
  }

  .login-title {
    font-size: 20px;
  }

  .modal-grid {
    grid-template-columns: 1fr;
  }
}
</style>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      pay: {
        SecretCode: "",
        projectOwner: "",
        rentalPrice: 0,
        payment_Method: 0,
        cardNumber: "",
        expireDate: "",
        day: null,
        month: null,
        amount: 0,
        otp: "",
        session: null
      },
      check_Secret_code: false,
      check_card_number: false,
      check_otp: false,
      username: "Админ",
      password: null,
      sklad_id: 1,
      data: [],
      skladlist: [],
      Userlist: [],
      errors: ""
    };
  },
  methods: {
    SendSms() {
      let self = this;
      if (self.pay.cardNumber != "") {
        self.check_card_number = false;
        var username = self.data.username;
        var password = self.data.password;
        axios({
          method: "post",
          url: self.data.url + "/paymentSiteCard",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Basic " + Buffer.from(username + ':' + password).toString('base64')
          },
          data: {
            SecretCode: self.pay.SecretCode,
            cardNumber: self.pay.cardNumber,
            expireDate: self.pay.expireDate,
            day: self.pay.day,
            month: self.pay.month,
            amount: self.pay.amount
          }
        }).then(function (response) {
          if (response.data.error == false) {
            self.pay.session = response.data.data.session;
            self.$bvToast.toast(self.$t('Смс код жўнатилди'), {
              title: self.$t('Муваффаққиятли'),
              toaster: 'b-toaster-bottom-center',
              variant: 'success',
              solid: true
            });
          } else {
            self.$store.state.errors = response.data.message;
          }
        });
      } else {
        self.check_card_number = true;
      }
    },
    SendPay() {
      let self = this;

      if (self.pay.otp != "") {
        self.check_otp = false;
        var username = self.data.username;
        var password = self.data.password;
        axios({
          method: "post",
          url: self.data.url + "/confirmPayment",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Basic " + Buffer.from(username + ':' + password).toString('base64')
          },
          data: {
            SecretCode: self.pay.SecretCode,
            session: self.pay.session,
            otp: self.pay.otp
          }
        }).then(function (response) {
          if (response.data.error == false) {
            self.$bvModal.hide("modal-pay");
            let date = response.data.data.date.slice(0, 10);
            self.$bvToast.toast(self.$t('Тўлов қилинди! Кейинги тўлов санаси: ') + date, {
              title: self.$t('Муваффаққиятли'),
              toaster: 'b-toaster-bottom-center',
              variant: 'success',
              solid: true
            });
            self.pay.SecretCode = "";
            self.pay.projectOwner = "";
            self.pay.rentalPrice = 0;
            self.pay.payment_Method = 0;
            self.pay.cardNumber = "";
            self.pay.expireDate = "";
            self.pay.day = null;
            self.pay.month = null;
            self.pay.amount = 0;
            self.pay.otp = "";
            self.pay.session = null;
          } else {
            self.$store.state.errors = response.data.message;
          }
        });
      } else {
        self.check_otp = true;
      }
    },
    FocusToSecret() {
      this.$refs.secretcode.focus();
    },
    CheckSecretCode() {
      let self = this;
      if (self.pay.SecretCode != "") {
        self.check_Secret_code = false;
        var username = self.data.username;
        var password = self.data.password;
        axios({
          method: "post",
          url: self.data.url + "/checkSecretCode",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Basic " + Buffer.from(username + ':' + password).toString('base64')
          },
          data: {
            SecretCode: self.pay.SecretCode
          }
        }).then(function (response) {
          if (response.data.error == false) {
            self.pay.projectOwner = response.data.data.projectOwner;
            self.pay.rentalPrice = response.data.data.rentalPrice;
            self.pay.payment_Method = response.data.data.payment_Method;
          } else {
            self.$store.state.errors = response.data.data.answer;
          }
        });
      } else {
        self.check_Secret_code = true;
      }
    },
    Summa() {
      if (this.pay.SecretCode != "") {
        if (this.pay.payment_Method == 0) {
          this.pay.amount = this.pay.day * this.pay.rentalPrice;
          this.pay.day = parseInt(this.pay.day);
          this.pay.month = 0;
        } else if (this.pay.payment_Method == 1) {
          this.pay.amount = this.pay.month * this.pay.rentalPrice;
          this.pay.month = parseInt(this.pay.month);
          this.pay.day = 0;
        }
      } else {
        this.check_Secret_code = true;
      }
    },
    ClientPay() {
      this.$bvModal.show("modal-pay");
    },
    Programmer() {
      console.log(this.password);
      let self = this;
      axios
        .get("api/v1/registration/get-phone-sms/" + self.password)
        .then(function (response) {
          if (response.data.error == false) {
            self.$router.push({ path: "/programmersms/" + self.password });
          } else {
            self.$store.state.errors = response.data.message;
          }
        });
    },
    Focus() {
      this.$refs.focused.focus();
    },
    Userlists() {
      let self = this;
      axios
        .get("api/v1/users/usernames/" + self.sklad_id, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(function (response) {
          self.Userlist = response.data;
        });
    },
    Skladlist() {
      let self = this;
      axios
        .get("api/v1/sklads/skladnames")
        .then(function (response) {
          self.skladlist = response.data;
        });
    },
    Updatetime() {
      let self = this;
      axios({
        method: "post",
        url: "api/v1/sklads/update-datetime",
        data: {
          sklad_id: self.sklad_id
        }
      }).then(function (response) {

      });
    },
    Login() {
      let self = this;
      self.errors = "";
      if (self.password == null) {
        self.errors = "Паролни тўлдиринг";
      } else {
        axios({
          method: "post",
          url: "api/v1/users/login",
          data: {
            sklad_id: self.sklad_id,
            username: self.username,
            password: self.password,
            confirm_password: self.password
          }
        }).then(function (response) {
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("user_role", response.data.role);
          localStorage.setItem("user_id", response.data.id);
          localStorage.setItem("username", response.data.username);
          localStorage.setItem("sklad_id", response.data.sklad_id);
          localStorage.setItem("rules", JSON.stringify(response.data.rules));
          if (response.data.menu_json) {
            localStorage.setItem("menu_json", JSON.stringify(response.data.menu_json));
          }
          self.$store.state.user_role = localStorage.getItem('user_role');
          if (response.data.role == 'SuperUser') {
            self.$router.push({ name: "Chiqim qoshish" });
          } else {
            self.$router.push({ name: "Бош сахифа" });
          }
        });
      }
    }
  },
  mounted() {

    localStorage.removeItem("user_id");
    localStorage.removeItem("token");
    localStorage.removeItem("user_role");
    localStorage.removeItem("rules");
    localStorage.removeItem("menu_json");
    let self = this;
    $("body").on("keydown", "#programmer", function (e) {
      if (e.keyCode == 112) {
        self.Programmer();
      } else if (e.keyCode == 113) {
        if (self.password == 'bdmadminuchunparol') {
          console.log('ishladi');
          self.Userlist.push({ 'id': 0, 'username': 'BDM Админ' });
        }
      } else {
        return true;
      }
    });
    if (localStorage.getItem('sklad_id') != undefined) {
      this.sklad_id = parseInt(localStorage.getItem('sklad_id'));
    }
    this.Userlists();
    this.Skladlist();
    this.Focus();
    axios
      .get("http://bdm.uz/server/url")
      .then(function (response) {
        self.data = response.data;
      });
  }
};
</script>
